import { render, staticRenderFns } from "./TitleTextCenter.vue?vue&type=template&id=27bc7460&scoped=true&"
import script from "./TitleTextCenter.vue?vue&type=script&lang=js&"
export * from "./TitleTextCenter.vue?vue&type=script&lang=js&"
import style0 from "./TitleTextCenter.vue?vue&type=style&index=0&id=27bc7460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc7460",
  null
  
)

export default component.exports